<template>
  <div
    v-if="isQzTrayInstalled && isPrinterConfigured"
    class="d-inline"
    @click="sendJobToPrinter"
  >
    <slot name="activator" />
  </div>
  <div
    v-else
    class="pt-6 pb-6"
  >
    <v-alert
      class="d-inline-block"
      color="red"
      text
    >
      <v-icon
        class="mr-2"
        color="red"
      >fal fa-exclamation-triangle</v-icon>
      {{ $t('No {0}', [$t('Printer')]) }}
    </v-alert>
  </div>
</template>

<script>
import qz from '@/../own_modules/qz-tray/qz-tray'
import { getReportLogo, getReportHtml } from '@/utils/report-layout'
import { mapState, mapGetters } from 'vuex'
import cashRegisterService from '@/services/cash-registers'

export default {
  name: 'CashRegisterReportPrinter',

  props: {
    reportObject: {
      default: null,
      type: Object
    }
  },

  data: () => ({
    cashRegisterReport: {}
  }),

  computed: {
    ...mapState(['printer', 'isQzTrayInstalled']),
    ...mapGetters(['isPrinterConfigured'])
  },

  watch: {
    reportObject: {
      immediate: true,
      handler (reportObject) {
        this.cashRegisterReport = Object.assign({}, reportObject)
      }
    }
  },

  methods: {
    sendJobToPrinter () {
      this.$wait.start('printing report')
      const config = qz.configs.create(this.printer || this.defaultPrinter, {
        scaleContent: false,
        rasterize: false,
        margins: {
          right: 0.10,
          left: 0.10
        }
      })

      qz.print([config, config], [
        getReportLogo(this.cashRegisterReport),
        getReportHtml(this.cashRegisterReport)
      ])
        .then(() => cashRegisterService.printedReport(this.cashRegisterReport.uuid))
        .finally(() => this.$wait.end('printing report'))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cash-register-reports/CashRegisterReportPrinter.vue